import React from 'react';
import { Box, CloseButton, Modal, Text } from '@wix/design-system';
import SparklesGradient from '../../assets/images/SparklesGradient.svg?url';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import s from './DomainInsight.module.scss';
export const BusinessNameAiInsightsModal = _ref => {
  let isOpen = _ref.isOpen,
    name = _ref.name,
    onRequestClose = _ref.onRequestClose;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  if (!name) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: Boolean(isOpen),
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: true,
    transition: "moveVertical",
    screen: "mobile",
    dataHook: "business-name-insights-modal"
  }, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    bottom: "12px",
    left: "12px",
    right: "12px",
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0px 8px 24px 0px rgba(19, 23, 32, 0.18)"
  }, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: "24px",
    right: "24px",
    zIndex: 1
  }, /*#__PURE__*/React.createElement(CloseButton, {
    skin: "standardFilled",
    size: "medium",
    onClick: onRequestClose,
    dataHook: "business-name-insights-close"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "14px",
    padding: "24px",
    boxSizing: "border-box",
    dataHook: "business-name-tooltip"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle",
    gap: "4px"
  }, /*#__PURE__*/React.createElement("img", {
    src: SparklesGradient,
    alt: ""
  }), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    className: s.gradient
  }, t('domain_search_suite.results.insight_widget.header'))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, name.name), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin"
  }, name.reasoning ?? '')))));
};
//# sourceMappingURL=BusinessNameAiInsightsModal.js.map